import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import { connect } from 'react-redux'
import { getCodeMain } from 'actions/pulpitActions'
import ReportButtons  from '../common/ReportButtons'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';
import moment from "moment";

const MainTable = (props) => {
  const {
    tableData, getCodeMain, loadingMain, showOPK, showOPKtoggle, refresh, dateFrom, dateBefore
  } = props
  const valueConvert = (val) => {
    if(typeof val === typeof 1) return Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
    return val
  }
  let title = "Rodzaj działalności";
  if(dateFrom) title += " od "+moment(dateFrom).format("YYYY-MM")
  if(dateBefore) title += " do "+moment(dateBefore).format("YYYY-MM")
        
  //DOC
  const getTableRow = (values, format={}, mergeCells={col:[], row: []}) => {
    let row = []
    values.forEach( (val, i) => {
      row.push(new TableCell({
        children: [
          new Paragraph({
            children: [new TextRun({ 
              text: String(val), 
              font:'Calibri', 
              bold: format.bold, 
              color: format.textColor,
              size: format.size,
              allCaps: format.allCaps
            })],
            alignment: format.align[i]
          })
        ],
        rowSpan: mergeCells.row[i]?mergeCells.row[i]:1,
        columnSpan: mergeCells.col[i]?mergeCells.col[i]:1,
        verticalAlign: VerticalAlign.CENTER,
        shading: {
          fill: format.backgroundColor
        },
        margins: {
          marginUnitType: WidthType.DXA,
          top: 100, bottom: 100, left: 100, right: 100
        }
      }))
    })
    return row
  }
  
  const downloadDoc = () => {
    //TABLE
    let rows = []
    const headerStyle = {
      bold: true, backgroundColor:'#b6b6b6', textColor: 'white', size: '22', allCaps: true,
      align: Array(6).fill(AlignmentType.CENTER)
    }
    const bodyStyle = {
      bold: false, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: false,
      align: Array(2).fill(AlignmentType.LEFT).concat(Array(4).fill(AlignmentType.RIGHT))
    }
    //header
    rows.push(new TableRow({
      children: getTableRow([
        'Kod funkcji',
        'Rodzaj działalności',
        'Koszt własny sprzedaży [zł]',
        'Przychód całkowity [zł]',
        'Wynik finansowy [zł]',
        '% pokrycia kosztów przychodami',
      ], headerStyle),
      tableHeader: true
    }))
    //body
    Object.entries(tableData).map(([opk, item]) => {
        rows.push(new TableRow({
            children: getTableRow([
                opk,
                item.name===undefined?'':item.name,
                valueConvert(item['Koszt własny sprzedaży']),
                valueConvert(item['Przychód całkowity']),
                valueConvert(item['Wynik finansowy']),
                valueConvert(item['% pokrycia kosztów przychodami']),
            ], opk==='Wartość ogółem'?{...bodyStyle, bold: true}:bodyStyle)
        }))
        if(item['children'] !== undefined && showOPK[opk]){
          if(Object.getOwnPropertyNames(item['children']).length===0){
            rows.push(new TableRow({
              children: getTableRow(['Brak danych do wyświetlenia'], 
              {...bodyStyle, backgroundColor:'white' }, {col:[6], row: []})
            }))
          }else{
            Object.entries(item['children']).map(([opk2, item2]) => {
                rows.push(new TableRow({
                    children: getTableRow([
                        opk2,
                        item2.name,
                        valueConvert(item2['Koszt własny sprzedaży']),
                        valueConvert(item2['Przychód całkowity']),
                        valueConvert(item2['Wynik finansowy']),
                        valueConvert(item2['% pokrycia kosztów przychodami'])
                    ], {...bodyStyle, backgroundColor:'white' })
                }))
                return 0
            })
          }
        }
        return 0
    })

    let table = new Table({
      rows: rows,
      width: { size: 100, type: WidthType.PERCENTAGE}
    })

    //DOCUMENT
    let paragraphs = [
      new Paragraph({
        children:[
          new TextRun({text: title+'\n\n', font:'Calibri', bold: true, size: 26 })
        ],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { after: 200 }
      }),
      table
    ]

    let doc = new Document({ 
        sections: [{
            properties: { page: { 
                size: { 
                    // orientation: PageOrientation.LANDSCAPE,
                    height: convertMillimetersToTwip(210),
                    width: convertMillimetersToTwip(297) 
                },
                margin: {
                    top: convertMillimetersToTwip(15),
                    right: convertMillimetersToTwip(15),
                    bottom: convertMillimetersToTwip(15),
                    left: convertMillimetersToTwip(15),
                },
            }},
            children: paragraphs
        }] 
    })

    // doc.Settings.addCompatibility().doNotExpandShiftReturn();
    Packer.toBlob(doc).then(blob =>{
      saveAs(blob, title+'.doc')
    })
  }
  //CSV
  const downloadCSV = () => {
    var csv = [];
    var rows = document.querySelectorAll(`#mainTable tr`);
    
    for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll("td, th");
        
        for (var j = 0; j < cols.length; j++)
        // if(j===1 && i===0){row.push('KOD PROCEDURY WG KLASYFIKACJI ICD-9')} 
        // else if(j===2 && i===0){row.push('KOD PROCEDURY WG ŚWIADCZENIODAWCY')} 
        // else if(j===6 && i===0){row.push('ŁĄCZNIE JEDNOSTKOWY KOSZT NORMATYWNY W ZŁ')} 
        // else{   
          row.push(cols[j].innerText)
          // ;} 
        
        csv.push(row.join(";"));		}
        csv = csv.join("\n")

    var csvFile;
    var downloadLink;
    var universalBOM = "\uFEFF";
    csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
    downloadLink = document.createElement("a");
    downloadLink.download = title + ".csv";
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  const downloadXlsx = () =>{
    var wb = XLSX.utils.table_to_book(document.getElementById('mainTable'), {sheet:"Rodzaj działalności", raw:true});
        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), title + ".xlsx");
  }
  const s2ab = (s)=>{
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
  }

  if(tableData){
    return (
      <div className=''>
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} color='pulpit'/>
        <table className='table table-border tablePulpit' id="mainTable">
          <thead className=''>
            <tr>
              <th className='rt-td'>Kod funkcji</th>
              <th>Rodzaj działalności</th>
              <th style={{width: '12%', minWidth: '170px'}}>Koszt własny sprzedaży [zł]</th>
              <th style={{width: '12%', minWidth: '170px'}}>Przychód całkowity [zł]</th>
              <th style={{width: '12%', minWidth: '170px'}}>Wynik finansowy [zł]</th>
              <th style={{width: '12%', minWidth: '170px'}}>% pokrycia kosztów przychodami</th>
            </tr>
          </thead>
          <tbody className='rt-tbody'>
            {Object.entries(tableData).map(([opk, item], i)  => {
              return (<React.Fragment key={`mainTableDash-${i}`}><tr className='rt-tr tryColor' style={opk==='Wartość ogółem'?{fontWeight: 'bold'}:{}}>
                {opk!=='Wartość ogółem' ?
                  <td className = "rt-td" onClick={()=>showOPKtoggle(opk)} style={{cursor: 'pointer',width:"150px"}}>
                    {!showOPK[opk] ?<i className="nc-icon nc-minimal-right" style={{paddingRight: '5px', color:"rgb(69, 79, 134)"}}></i>:<i className="nc-icon nc-minimal-down" style={{marginRight: '5px',color:"rgb(69, 79, 134)"}}></i>}
                    {opk}
                  </td>
                  :<td>{opk}</td>
                }
                <td className='text-uppercase'>{item['name']}</td>
                <td className="rightAlignCell">{valueConvert(item["Koszt własny sprzedaży"])}</td>
                <td className="rightAlignCell">{valueConvert(item["Przychód całkowity"])}</td>
                <td className="rightAlignCell">{valueConvert(item["Wynik finansowy"])}</td>
                <td className="rightAlignCell">{valueConvert(item["% pokrycia kosztów przychodami"])}%</td>
              </tr>
              {item['children']!==undefined  && showOPK[opk] && <>
                    {Object.getOwnPropertyNames(item['children']).length===0?
                      <tr><td colSpan='6'><i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i></td></tr>:
                      Object.entries(item['children']).map(([opk2, item2], i2) => {
                        return (<>
                        <tr key={opk2} className='rt-tr'>
                            <td className='rt-td' style={{width:"120px"}}>
                              {/* <i className="nc-icon nc-minimal-right" style={{marginRight: '5px', marginLeft: '15px'}}></i> */}
                            <span style={{paddingRight: '5px', paddingLeft: '15px'}}>{opk2}</span> 
                            </td>
                            <td className='rt-td'>{item2['name']}</td>
                            <td className='rt-td rightAlignCell'>{valueConvert(item2["Koszt własny sprzedaży"])}</td>
                            <td className='rt-td rightAlignCell'>{valueConvert(item2["Przychód całkowity"])}</td>
                            <td className='rt-td rightAlignCell'>{valueConvert(item2["Wynik finansowy"])}</td>
                            <td className='rt-td rightAlignCell'>{valueConvert(item2["% pokrycia kosztów przychodami"])}%</td>
                          </tr>
                        </>)
                      })
                    }</>
                  }
              </React.Fragment>)
            })}
          </tbody>
        </table>
      </div>
    )
  }else{
    return <Spinner/>
  }
}
MainTable.propTypes = {
  tableData: PropTypes.object,
}
const mapStateToProps = state => ({
  loadingMain: state.pulpitReducer.loadingMain
})
export default connect(mapStateToProps,{getCodeMain})(MainTable)
